export default __webpack_public_path__ + "static/media/Page8.4796a2b6.txt";